export default "__VITE_ASSET__DaIA1ToL__"